const dev = process?.env?.NODE_ENV === 'development'
export const getRealMedialUrl = url => {
  const res =  (url && url.indexOf('http://') === 0) ? (url.replace('http://', 'https://')) : url
  console.log(res)
  return res
}